/**
 * Utility function to check if a URL points to a video file
 * Extracted from campaignHelper.ts for standalone use
 *
 * @param url - The URL to check
 * @returns true if the URL contains a video file extension, false otherwise
 */
export const isVideoFile = (url?: string): boolean => {
  if (!url) return false;
  const videoExtensions = [".mp4", ".mov", ".avi", ".wmv", ".flv", ".webm"];
  const lowerUrl = url.toLowerCase();
  return videoExtensions.some((ext) => lowerUrl.includes(ext));
};
